var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "store-close-agree-box" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isPageLoading,
            expression: "isPageLoading",
          },
        ],
        staticClass: "fromLoading",
      },
      [_c("Spin")],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "input_box" },
      [
        _c("span", { staticClass: "label-txt" }, [_vm._v("审批意见：")]),
        _vm._v(" "),
        _c("Input", {
          staticClass: "ref_input",
          attrs: { placeholder: "审批意见" },
          model: {
            value: _vm.inputValue,
            callback: function ($$v) {
              _vm.inputValue = $$v
            },
            expression: "inputValue",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "pop-btn" },
      [
        _c(
          "Button",
          {
            staticClass: "sav-btn",
            attrs: { type: "error" },
            on: { click: _vm.objectSave },
          },
          [_c("span", [_vm._v(_vm._s(_vm.chineseName.CONFIRM))])]
        ),
        _vm._v(" "),
        _c("Button", { staticClass: "cancel-btn", on: { click: _vm.cancel } }, [
          _c("span", [_vm._v(_vm._s(_vm.chineseName.CANCEL))]),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }